import { Injectable, computed, signal } from '@angular/core';

import { AuthUser } from '../../models/auth-session.model';

/**
 * UI state for the auth feature: what the login screen needs to render.
 *
 * The session itself (the bearer token) lives in core's AuthService, because
 * the route guard and the token interceptor both depend on it and core must not
 * reach into a feature. This store holds the surrounding view state only.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthStore {
  private readonly _user = signal<AuthUser | null>(null);
  private readonly _loading = signal(false);
  private readonly _error = signal<string | null>(null);

  readonly user = this._user.asReadonly();
  readonly loading = this._loading.asReadonly();
  readonly error = this._error.asReadonly();

  readonly hasError = computed(() => this._error() !== null);

  setUser(user: AuthUser | null): void {
    this._user.set(user);
  }

  setLoading(loading: boolean): void {
    this._loading.set(loading);
  }

  setError(error: string | null): void {
    this._error.set(error);
  }

  reset(): void {
    this._user.set(null);
    this._loading.set(false);
    this._error.set(null);
  }
}
